import { useEffect } from 'react';
import { ref, onChildAdded, remove } from 'firebase/database';
import { database } from './firebase-config';
import { FirebaseMessage, FirebaseUserModel } from '../../../types';
import { storeFirebaseUser } from '../../api/users-api';
import { useStore } from '../../components/state/zustand-store';

const useFirebaseKeepAlive = (firebaseUser: FirebaseUserModel) => {
  const { setFirebaseUser } = useStore();

  useEffect(() => {
    if (firebaseUser.firebaseDbPath === '') return;

    const dbRef = ref(database, firebaseUser.firebaseDbPath);
    const removeListener = onChildAdded(dbRef, (data) => {
      if (data) {
        data.forEach((child) => {
          const message: FirebaseMessage = child.val();
          if (message.type === 'keepAlive') {
            // update firebase user
            storeFirebaseUser({
              ...firebaseUser,
              alive: Date.now(),
              lastKeepAliveMessageSent: parseInt(child.key),
            });

            // update zustand store
            setFirebaseUser({
              ...firebaseUser,
              alive: Date.now(),
              lastKeepAliveMessageSent: parseInt(child.key),
            });

            // delete message
            const dbRef = ref(
              database,
              `${firebaseUser.firebaseDbPath}/${child.key}`
            );
            remove(dbRef);
          }
        });
      }
    });

    return () => {
      removeListener();
    };
  }, [firebaseUser, setFirebaseUser]);
};

export default useFirebaseKeepAlive;
